// FNV-1a 32-bit, returned as short base36 string
export function hash8(input: string, seed = 0): string {
  let h = 0x811c9dc5 ^ seed;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    // 32-bit FNV-1a mixing
    h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
  }
  // unsigned, base36, fixed length 8
  return (h >>> 0).toString(36).padStart(8, '0').slice(0, 8);
}
